import useLatest from "hooks/useLatest";
import React, { useEffect, useState } from "react";
import { getBankAccounts } from "sources/books/legalPersons";

export const formatLegalPersonBankAccountLabel = (account) => {
    const label = [account.name, account.bankName, account.settlementAccount].filter(Boolean).join(" - ");
    return label || `Счет ${account.id}`;
};

export default function LegalPersonBankAccountSelect({ legalPersonId, value, setValue, renderSelect, config }) {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const valueRef = useLatest(value);
    const setValueRef = useLatest(setValue);

    useEffect(() => {
        setAccounts([]);
        setNotFound(false);

        if (!legalPersonId) {
            return;
        }

        let active = true;
        setLoading(true);
        getBankAccounts(legalPersonId)
            .then((data) => {
                if (!active) {
                    return;
                }

                const nextAccounts = data || [];
                const selectedValue = valueRef.current;
                const selectedAccountExists =
                    selectedValue && nextAccounts.some((account) => `${account.id}` === `${selectedValue}`);
                const defaultAccount = nextAccounts.find((account) => account.isDefault);
                const accountToSelect = defaultAccount || (nextAccounts.length === 1 ? nextAccounts[0] : null);

                setAccounts(nextAccounts);

                if (selectedValue && !selectedAccountExists) {
                    setNotFound(true);
                    setValueRef.current({
                        name: "legalPersonBankAccountId",
                        value: null,
                        option: null,
                    });
                    return;
                }

                if (!selectedValue && accountToSelect) {
                    setValueRef.current({
                        name: "legalPersonBankAccountId",
                        value: accountToSelect.id,
                        option: accountToSelect,
                    });
                }
            })
            .catch(() => undefined)
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [legalPersonId, setValueRef, valueRef]);

    if (!legalPersonId || (!loading && accounts.length === 0 && !value && !notFound)) {
        return null;
    }

    const options = accounts.map((account) => ({
        label: formatLegalPersonBankAccountLabel(account),
        value: account.id,
        option: account,
    }));
    const notFoundMessage =
        accounts.length === 0
            ? "Ранее выбранный банковский счет больше недоступен. У юридического лица нет доступных счетов."
            : "Ранее выбранный банковский счет больше недоступен. Выберите актуальный счет.";

    return renderSelect({
        ...config.legalPersonBankAccountId,
        options,
        disabled: loading,
        unClearable: accounts.length > 0,
        onChange: (changedData) => {
            setNotFound(false);
            setValue(changedData);
        },
        fieldWrapper: "col-sm-8 col-md-5",
        bWrapper: "row form-group",
        inputBottomText: notFound ? <small className="text-warning">{notFoundMessage}</small> : null,
    });
}
